export const RAWB0TS_ADDRESS = '0x9e03fFA64e83d927F4FCC44A19167821Ea90C0aB';
export const PLATOKEN_ADDRESS = '0x5A3D0128bA42BF45c10771046B89faD349D79d6c';
export const NETWORK_NAME = 'Goerli'; //'Ethereum Mainnet';
export const NETWORK_SYMBOL = 'ETH';
export const NETWORK_ID = '5'; //'1';
export const NETWORK_CHAIN_ID = '0x5'; //'0x1';
export const NETWORK_RPC = 'https://goerli.infura.io/v3/92a27d14167a4ef195e0311bc4100901'; //'https://mainnet.infura.io/v3/92a27d14167a4ef195e0311bc4100901';
export const MAX_PRESALE_MINT = 1;
export const MAX_SALE_MINT = 2;
export const MAX_TOT_PRESALE_MINT = 666;
export const PRESALE_PRICE = 0.000045; //0.045;
export const SALE_PRICE = 0.00009; //0.09;
